"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formatter = _interopRequireDefault(require("./utils/formatter"));

var _calculatePosition = _interopRequireDefault(require("./utils/calculatePosition"));

var _syntheticEvent = _interopRequireDefault(require("../../utils/syntheticEvent"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var _wrapper = _interopRequireDefault(require("./style/wrapper"));

var _ClickAwayListener = _interopRequireDefault(require("../ClickAwayListener"));

var _Input = _interopRequireDefault(require("../Input"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _theme = require("./theme");

var _calendar = _interopRequireDefault(require("./style/calendar"));

var _reactSpring = require("react-spring");

var _picker = _interopRequireDefault(require("./style/picker"));

var _DatePicker = _interopRequireDefault(require("../DatePicker"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AnimatedPicker = (0, _reactSpring.animated)(_picker["default"]);

var DateInput = _react["default"].forwardRef(function (_ref, ref) {
  var onFocus = _ref.onFocus,
      minPickerOffset = _ref.minPickerOffset,
      onBlur = _ref.onBlur,
      elementRef = _ref.elementRef,
      onChange = _ref.onChange,
      theme = _ref.theme,
      style = _ref.style,
      className = _ref.className,
      stringify = _ref.stringify,
      value = _ref.value,
      disabled = _ref.disabled,
      minYear = _ref.minYear,
      maxYear = _ref.maxYear,
      minMonth = _ref.minMonth,
      maxMonth = _ref.maxMonth,
      yearChange = _ref.yearChange,
      allowedWeekDays = _ref.allowedWeekDays,
      deniedDates = _ref.deniedDates,
      allowedDates = _ref.allowedDates,
      firstDay = _ref.firstDay,
      isPeriod = _ref.isPeriod,
      layoutDate = _ref.layoutDate,
      isForbiddenDate = _ref.isForbiddenDate,
      Component = _ref.component,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["onFocus", "minPickerOffset", "onBlur", "elementRef", "onChange", "theme", "style", "className", "stringify", "value", "disabled", "minYear", "maxYear", "minMonth", "maxMonth", "yearChange", "allowedWeekDays", "deniedDates", "allowedDates", "firstDay", "isPeriod", "layoutDate", "isForbiddenDate", "component"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      position = _useState6[0],
      setPosition = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      lineHeight = _useState8[0],
      setLineHeight = _useState8[1];

  var root = (0, _react.useRef)(null);
  var input = (0, _react.useRef)(null);
  var picker = (0, _react.useRef)(null);
  var handleRootHover = (0, _react.useCallback)(function () {
    return setHover(true);
  }, []);
  var handleRootBlur = (0, _react.useCallback)(function () {
    return setHover(false);
  }, []);
  var handleBlur = (0, _react.useCallback)(function (event) {
    var _root$current;

    // блюр срабатывает так же при выборе элемента из списка, в таком случае нам не нужна обработка введенных в инпут данных
    if (event.relatedTarget && !((_root$current = root.current) === null || _root$current === void 0 ? void 0 : _root$current.contains(event.relatedTarget))) {
      setActive(false);

      if (typeof onBlur === 'function') {
        onBlur(event);
      }
    }
  }, [onBlur]);
  var handleFocus = (0, _react.useCallback)(function (e) {
    setActive(true);

    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  }, [onFocus]);
  var handleCalendarIconClick = (0, _react.useCallback)(function () {
    var _input$current;

    return (_input$current = input.current) === null || _input$current === void 0 ? void 0 : _input$current.focus();
  }, [input.current]);
  var handleCalendarSubmit = (0, _react.useCallback)(function (value) {
    var _input$current2, _input$current3, _input$current4;

    setActive(false);
    var target = {
      name: (_input$current2 = input.current) === null || _input$current2 === void 0 ? void 0 : _input$current2.name,
      type: (_input$current3 = input.current) === null || _input$current3 === void 0 ? void 0 : _input$current3.type,
      focus: (_input$current4 = input.current) === null || _input$current4 === void 0 ? void 0 : _input$current4.focus,
      value: value
    };

    if (typeof onChange === 'function') {
      onChange((0, _syntheticEvent["default"])(target));
    }
  }, [onChange]);
  var handleCalendarCancel = (0, _react.useCallback)(function () {
    return setActive(false);
  }, []);
  var handleClickAway = (0, _react.useCallback)(function (event) {
    var _root$current2;

    if (active && !((_root$current2 = root.current) === null || _root$current2 === void 0 ? void 0 : _root$current2.contains(event.target))) {
      setActive(false);
    }
  }, [root.current, active]); // add refs

  (0, _react.useEffect)(function () {
    if (ref) {
      ref.current = input.current;
    }

    if (typeof elementRef === 'function') {
      elementRef(input.current);
    } else if ((0, _typeof2["default"])(elementRef) === 'object') {
      elementRef.current = input.current;
    }

    return function () {
      if (ref) {
        ref.current = null;
      }

      if (typeof elementRef === 'function') {
        elementRef(null);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = null;
      }
    };
  }, [ref, elementRef, input.current]);
  (0, _react.useEffect)(function () {
    if (active && picker.current && root.current) {
      setPosition((0, _calculatePosition["default"])(root.current, picker.current, minPickerOffset));
    }
  }, [active]);
  (0, _react.useEffect)(function () {
    var _input$current5;

    return setLineHeight((_input$current5 = input.current) === null || _input$current5 === void 0 ? void 0 : _input$current5.offsetHeight);
  }, [input.current]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style, theme]);
  var inputStyle = (0, _react.useMemo)(function () {
    var _theme$palette;

    return _objectSpread({}, (0, _omit["default"])(style, _theme.reservedKeys), {
      width: '100%',
      paddingRight: ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.gutter) * 4 + 'px'
    });
  }, [style]);
  var appearance = typeof memoTheme.appearance === 'string' ? _react["default"].createElement("img", {
    src: memoTheme.appearance,
    alt: "calendar"
  }) : _react["default"].createElement(memoTheme.appearance);
  var transitions = (0, _reactSpring.useTransition)(active, active, _theme.animation);
  return _react["default"].createElement(_root["default"], {
    className: className,
    theme: memoTheme,
    ref: root
  }, _react["default"].createElement(_wrapper["default"], {
    onMouseEnter: handleRootHover,
    onMouseLeave: handleRootBlur
  }, active ? _react["default"].createElement(_ClickAwayListener["default"], {
    node: root.current,
    onClickAway: handleClickAway
  }) : null, _react["default"].createElement(Component, (0, _extends2["default"])({
    ref: input,
    onFocus: handleFocus,
    onBlur: handleBlur,
    value: stringify ? stringify(value) : value,
    style: inputStyle,
    disabled: disabled,
    onChange: onChange
  }, rest)), _react["default"].createElement(_calendar["default"], {
    theme: memoTheme,
    disabled: disabled,
    hover: hover,
    onClick: handleCalendarIconClick,
    height: lineHeight
  }, appearance), transitions.map(function (_ref2) {
    var item = _ref2.item,
        props = _ref2.props,
        key = _ref2.key;
    return item && _react["default"].createElement(AnimatedPicker, {
      key: key,
      theme: memoTheme,
      style: _objectSpread({}, props, {}, position)
    }, _react["default"].createElement(_DatePicker["default"], {
      minYear: minYear,
      maxYear: maxYear,
      minMonth: minMonth,
      maxMonth: maxMonth,
      yearChange: yearChange,
      allowedWeekDays: allowedWeekDays,
      deniedDates: deniedDates,
      allowedDates: allowedDates,
      firstDay: firstDay,
      isPeriod: isPeriod,
      value: value,
      stringify: stringify,
      onSubmit: handleCalendarSubmit,
      onCancel: handleCalendarCancel,
      layoutDate: layoutDate,
      isForbiddenDate: isForbiddenDate
    }));
  })));
});

DateInput.propTypes = {
  minYear: _propTypes["default"].number,
  maxYear: _propTypes["default"].number,
  minMonth: _propTypes["default"].number,
  maxMonth: _propTypes["default"].number,
  yearChange: _propTypes["default"].bool,
  allowedWeekDays: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].array]),
  deniedDates: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].array]),
  allowedDates: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].bool, _propTypes["default"].array, _propTypes["default"].string]),
  firstDay: _propTypes["default"].number,
  isPeriod: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  onFocus: _propTypes["default"].func,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default url("${calendar}")
     */
    appearance: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].func]),

    /**
     * @default palette.zOverlay
     */
    zIndex: _propTypes["default"].number,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  }),
  onBlur: _propTypes["default"].func,
  stringify: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  minPickerOffset: _propTypes["default"].number,
  layoutDate: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  isForbiddenDate: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
DateInput.defaultProps = {
  readOnly: true,
  stringify: _formatter["default"],
  minPickerOffset: 18,
  isForbiddenDate: null,
  component: _Input["default"]
};
var _default = DateInput;
exports["default"] = _default;